import { Button } from "@material-ui/core";
import {
  MenuItem,
  Modal,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Chat, User, UserFocus } from "phosphor-react";
import { useContext, useEffect, useState } from "react";
import { fpost } from "../../API/callsAPI";
import { MovieColabContext } from "../../Context/MovieColabContext";
import LeaveTeamModal from "./LeaveTeamModal";
import myTeamsPageStyles from "../MyTeamPageComponents/MyTeamsPageStyles";
import RemoveUserModal from "../MyTeamPageComponents/RemoveUserModal";

const MyTeamCollaboratorsTable = ({
  teamDetails,
  setRefreshCounter,
  projectUsers,
  selectedProject,
  setSnackValue,
  hideLeave,
}) => {
  const { loggedInUser } = useContext(MovieColabContext);

  const classes = myTeamsPageStyles();
  const [removeUserFromTeamModalData, setRemoveUserFromTeamModalData] =
    useState({
      isOpen: false,
      userDetails: null,
    });

  const [removeUserFromProjectModalData, setRemoveUserFromProjectModalData] =
    useState({
      isOpen: false,
      userDetails: null,
    });
  const [isLeaveTeamModalOpen, setIsLeaveTeamModalOpen] = useState(false);
  const [isLeaveProjectModalOpen, setIsLeaveProjectModalOpen] = useState(false);
  const [isTeamAdmin, setIsTeamAdmin] = useState(false);

  const handleUpdateUserRole = async ({ userId, newRole, userType }) => {
    try {
      const updateUserData = {
        url:
          userType === "team"
            ? `project-space/${teamDetails?.id}/update-role/`
            : `project/${selectedProject.id}/update-role/`,
        data: {
          user: userId,
          role: newRole,
        },
      };
      const res = await fpost(updateUserData);
      setSnackValue({
        isOpen: true,
        message: `SuccessFully Updated`,
        isError: false,
      });
      setRefreshCounter();
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  useEffect(() => {
    setIsTeamAdmin(loggedInUser?.id === teamDetails?.admin?.id);
  }, [loggedInUser, teamDetails]);

  return (
    <TableContainer>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <TableCell align="left" className={classes.tableHeaderCell}>
              Name
            </TableCell>
            <TableCell align="left" className={classes.tableHeaderCell}>
              Email
            </TableCell>
            <TableCell align="left" className={classes.tableHeaderCell}>
              Date Added
            </TableCell>
            <TableCell align="left" className={classes.tableHeaderCell}>
              Role
            </TableCell>
            <TableCell align="left" className={classes.tableHeaderCell}>
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {teamDetails?.admin && (
            <>
              <TableRow>
                <TableCell align="left" className={classes.tableCell}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div className={classes.userNameAvatar}>
                      {teamDetails?.admin?.first_name
                        ?.charAt(0)
                        .toUpperCase() ?? ""}
                      {teamDetails?.admin?.last_name?.charAt(0).toUpperCase() ??
                        ""}
                    </div>{" "}
                    {teamDetails?.admin?.first_name}{" "}
                    {teamDetails?.admin?.last_name}
                    <span style={{ color: "#606479" }}>
                      {loggedInUser?.id === teamDetails?.admin?.id ? "you" : ""}
                    </span>
                  </div>
                </TableCell>
                <TableCell align="left" className={classes.tableCell}>
                  {teamDetails?.admin?.email}
                </TableCell>
                <TableCell align="left" className={classes.tableCell}>
                  {new Intl.DateTimeFormat("en-US", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  }).format(new Date())}
                </TableCell>
                <TableCell align="left" className={classes.tableCell}>
                  Owner
                </TableCell>
                <TableCell align="left" className={classes.tableCell}>
                  {/* {loggedInUser?.id === teamDetails?.admin?.id && !hideLeave ? (
                    <Button
                      className={classes.leaveButton}
                      onClick={() => setIsLeaveTeamModalOpen(true)}
                    >
                      Leave
                    </Button>
                  ) : (
                    ""
                  )} */}
                </TableCell>
              </TableRow>
              {teamDetails?.collaborators?.map((team) => (
                <TableRow key={team.id}>
                  <TableCell align="left" className={classes.tableCell}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <div className={classes.userNameAvatar}>
                        {team?.first_name?.charAt(0).toUpperCase() ?? ""}
                        {team?.last_name?.charAt(0).toUpperCase() ?? ""}
                      </div>{" "}
                      {team?.first_name} {team?.last_name}
                      <span style={{ color: "#606479" }}>
                        {loggedInUser?.id === team?.id ? "you" : ""}
                      </span>
                    </div>
                  </TableCell>
                  <TableCell align="left" className={classes.tableCell}>
                    {team?.email}
                  </TableCell>
                  <TableCell align="left" className={classes.tableCell}>
                    {new Intl.DateTimeFormat("en-US", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }).format(new Date())}
                  </TableCell>
                  <TableCell align="left" className={classes.tableCell}>
                    {isTeamAdmin ? (
                      <Select
                        value={team?.role}
                        onChange={(e) =>
                          handleUpdateUserRole({
                            userId: team.id,
                            newRole: e.target.value,
                            userType: "team",
                          })
                        }
                        className={classes.selectRoleDropdown}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              backgroundColor: "#252A38",
                              color: "#fff !important",
                            },
                          },
                        }}
                        // labelId={`role-select-${index}`}
                        // id={`role-select-${index}`}
                      >
                        {/* <MenuItem value="admin" className={classes.singleRole}>
              <Shield size={20} />
              Admin
            </MenuItem> */}
                        <MenuItem
                          value="reviewer"
                          className={classes.singleRole}
                        >
                          <Chat size={20} />
                          Reviewer
                        </MenuItem>
                        <MenuItem value="user" className={classes.singleRole}>
                          <User size={20} />
                          User
                        </MenuItem>
                        <MenuItem
                          value="freelancer"
                          className={classes.singleRole}
                        >
                          <User size={20} />
                          Freelancer
                        </MenuItem>
                      </Select>
                    ) : (
                      team?.role
                    )}
                  </TableCell>
                  <TableCell align="left" className={classes.tableCell}>
                    {loggedInUser?.id === team?.id && !hideLeave ? (
                      <Button
                        className={classes.leaveButton}
                        onClick={() => setIsLeaveTeamModalOpen(true)}
                      >
                        Leave
                      </Button>
                    ) : loggedInUser?.id === teamDetails?.admin?.id &&
                      !hideLeave ? (
                      <Button
                        className={classes.removeButton}
                        onClick={() =>
                          setRemoveUserFromTeamModalData({
                            isOpen: true,
                            userDetails: team,
                          })
                        }
                      >
                        Remove
                      </Button>
                    ) : (
                      ""
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </>
          )}
          {projectUsers &&
            projectUsers?.map((team) => {
              return (
                <TableRow key={team.id}>
                  <TableCell align="left" className={classes.tableCell}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <div className={classes.userNameAvatar}>
                        {team?.first_name?.charAt(0).toUpperCase() ?? ""}
                        {team?.last_name?.charAt(0).toUpperCase() ?? ""}
                      </div>{" "}
                      {team?.first_name} {team?.last_name}
                      <span style={{ color: "#606479" }}>
                        {loggedInUser?.id === team?.id ? "you" : ""}
                      </span>
                    </div>
                  </TableCell>
                  <TableCell align="left" className={classes.tableCell}>
                    {team?.email}
                  </TableCell>
                  <TableCell align="left" className={classes.tableCell}>
                    {new Intl.DateTimeFormat("en-US", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }).format(new Date())}
                  </TableCell>
                  <TableCell align="left" className={classes.tableCell}>
                    {loggedInUser?.id === team?.id && team?.role === "admin" ? (
                      <span>Admin</span>
                    ) : (
                      <Select
                        value={team?.role}
                        onChange={(e) =>
                          handleUpdateUserRole({
                            userId: team.id,
                            newRole: e.target.value,
                            userType: "project",
                          })
                        }
                        disabled={
                          loggedInUser?.id === team?.id &&
                          team?.role === "admin"
                        }
                        className={classes.selectRoleDropdown}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              backgroundColor: "#252A38",
                              color: "#fff !important",
                            },
                          },
                        }}
                      >
                        <MenuItem value="admin" className={classes.singleRole}>
                          <UserFocus size={20} />
                          Admin
                        </MenuItem>
                        <MenuItem
                          value="reviewer"
                          className={classes.singleRole}
                        >
                          <Chat size={20} />
                          Reviewer
                        </MenuItem>
                        <MenuItem value="user" className={classes.singleRole}>
                          <User size={20} />
                          Artist
                        </MenuItem>
                        <MenuItem
                          value="freelancer"
                          className={classes.singleRole}
                        >
                          <User size={20} />
                          Freelancer
                        </MenuItem>
                      </Select>
                    )}
                  </TableCell>
                  <TableCell align="left" className={classes.tableCell}>
                    {loggedInUser?.id === team?.id ? (
                      <Button
                        className={classes.leaveButton}
                        onClick={() => setIsLeaveProjectModalOpen(true)}
                      >
                        Leave
                      </Button>
                    ) : loggedInUser?.id !== team?.id &&
                      team?.role !== "admin" ? (
                      <Button
                        className={classes.removeButton}
                        onClick={() =>
                          setRemoveUserFromProjectModalData({
                            isOpen: true,
                            userDetails: team,
                          })
                        }
                      >
                        Remove
                      </Button>
                    ) : (
                      ""
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
      <Modal
        open={removeUserFromTeamModalData.isOpen}
        onClose={() =>
          setRemoveUserFromTeamModalData({
            isOpen: false,
            userDetails: null,
          })
        }
        className={classes.flexCenter}
      >
        <RemoveUserModal
          userType="team"
          teamDetails={teamDetails}
          userDetails={removeUserFromTeamModalData?.userDetails}
          handleRefresh={() => {
            setRefreshCounter();
            setRemoveUserFromTeamModalData({
              isOpen: false,
              userDetails: null,
            });
          }}
          handleClose={() => {
            setRemoveUserFromTeamModalData({
              isOpen: false,
              userDetails: null,
            });
          }}
          setSnackValue={setSnackValue}
        />
      </Modal>
      <Modal
        open={removeUserFromProjectModalData.isOpen}
        onClose={() =>
          setRemoveUserFromProjectModalData({
            isOpen: false,
            userDetails: null,
          })
        }
        className={classes.flexCenter}
      >
        <RemoveUserModal
          userType="project"
          teamDetails={teamDetails}
          userDetails={removeUserFromProjectModalData?.userDetails}
          handleRefresh={() => {
            setRefreshCounter();
            setRemoveUserFromProjectModalData({
              isOpen: false,
              userDetails: null,
            });
          }}
          handleClose={() => {
            setRemoveUserFromProjectModalData({
              isOpen: false,
              userDetails: null,
            });
          }}
          selectedProject={selectedProject}
          setSnackValue={setSnackValue}
        />
      </Modal>
      <Modal open={isLeaveTeamModalOpen} className={classes.flexCenter}>
        <LeaveTeamModal
          handleClose={() => setIsLeaveTeamModalOpen(false)}
          teamDetails={teamDetails}
          handleRefresh={() => {
            setRefreshCounter();
          }}
          userType="team"
          setSnackValue={setSnackValue}
        />
      </Modal>
      <Modal open={isLeaveProjectModalOpen} className={classes.flexCenter}>
        <LeaveTeamModal
          handleClose={() => setIsLeaveProjectModalOpen(false)}
          handleRefresh={() => {
            setRefreshCounter();
          }}
          userType="project"
          selectedProject={selectedProject}
          setSnackValue={setSnackValue}
        />
      </Modal>
    </TableContainer>
  );
};

export default MyTeamCollaboratorsTable;
